import React, { Component } from "react";
import { Grid, Row, Col, Well } from "react-bootstrap";
import Item from "./Item";
import articles from "./config.json";
import "./App.css";

class App extends Component {
  render() {
    const listItems = articles.map(item => (
      <Item key={item.fileNames.toString()} data={item} />
    ));
    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title">
            <a href="http://www.atomic77.net/">Atomic</a>
          </h1>
        </header>
        <Grid>
          <Row className="show-grid">
            <Col md={8} mdOffset={2} xs={12}>
              <h1>デザインプレート</h1>
              <Well>
                <p>
                  デザインの型を作り、板ガラスを溶かして作りました。<br />色板の使用や塗装することによって、デザインの幅も広がります。<br />ご要望に応じたデザインから作成することも可能です。ご相談ください。
                </p>
                <address>
                  <a href="mailto:design@atomic77.net">お問い合わせはこちら</a>
                </address>
              </Well>
              {listItems}
            </Col>
          </Row>
        </Grid>
        <footer>
          <small>Copyright:(C) 2002 ATOMIC co.,ltd All rights reserved.</small>
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js